module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheCommonReader3"
    }
  }, [_vm._v("The Common Reader")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheCommonReader4"
    }
  }, [_vm._v("The Pastons and Chaucer")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On not knowing Greek")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Elizabethan Lumber Room")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes on an Elizabethan Play")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Montaigne")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Duchess of Newcastle")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rambling round Evelyn")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Defoe")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Addison")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader12a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lives of the Obscure—")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Taylors and Edgeworths")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Laetitia Pilkington")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jane Austen")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modern Fiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Jane Eyre” and “Wuthering Heights”")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Eliot")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Russian Point of View")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader19a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outlines—")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Miss Mitford")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Dr. Bentley")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Lady Dorothy Nevill")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. Archbishop Thomson")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Patron and the Crocus")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Modern Essay")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph Conrad")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('span', {
    attrs: {
      "href": "#/TheCommonReader27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How it strikes a Contemporary")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a54fe7f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheCommonReader2.vue
// module id = 66
// module chunks = 0